export default __webpack_public_path__ + "images/EK.5cc2c01.png";